<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="px-6 py-4 w-full">

  <div class="flex justify-content-between align-items-center mb-4 w-full">
    <p class="text-xl font-semibold">
      {{ 'layout.configurations.jira.title' | translate }}
    </p>

    <button 
      pButton
      type="button"
      icon="pi pi-plus"
      class="p-button-success p-button-icon-only"
      style="width: 3rem; height: 3rem;"
      (click)="openCreateModal()">
    </button>
  </div>

  <div class="w-full">
    <p-table [value]="jiraPkeys" [paginator]="true" [rows]="10" styleClass="p-datatable-sm w-full">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="pkey">
            {{ 'layout.configurations.jira.pkey' | translate }}
            <p-sortIcon field="pkey"></p-sortIcon>
          </th>
          <th>{{ 'layout.configurations.jira.status' | translate }}</th>
          <th style="width: 12rem">{{ 'layout.configurations.jira.actions' | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td><strong>{{ item.pkey }}</strong></td>
          <td>
            <p-tag 
              [value]="'layout.configurations.jira.statuses.' + item.status | translate" 
              [severity]="item.status === JiraStatus.ACTIVE ? 'success' : 'danger'">
            </p-tag>
          </td>
          <td>
            <div class="flex gap-2">
              <p-button icon="pi pi-trash" severity="danger" [outlined]="true" (onClick)="onDelete($event, item.id)"></p-button>
              <p-button icon="pi pi-pencil" severity="info" [outlined]="true" (onClick)="openEditModal(item)"></p-button>
              <p-button [icon]="item.status === 'ACTIVE' ? 'pi pi-ban' : 'pi pi-check-circle'" 
                        [severity]="item.status === 'ACTIVE' ? 'warning' : 'success'" 
                        [outlined]="true" (onClick)="onToggleStatus(item.id)">
              </p-button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p-dialog [header]="isEditMode ? ('layout.configurations.jira.dialog.editTitle' | translate) : ('layout.configurations.jira.dialog.createTitle' | translate)" [(visible)]="displayDialog" [modal]="true" [style]="{ width: '400px' }" [draggable]="false" [resizable]="false">
    <div class="p-fluid">
      
      <div class="field mb-3">
        <label class="font-bold">{{ 'layout.configurations.jira.pkey' | translate }} *</label>
        <input 
          type="text" 
          pInputText 
          [(ngModel)]="selectedPkey.pkey"
          [ngClass]="{'ng-invalid ng-dirty': selectedPkey.pkey && !isPkeyValid}"
          [placeholder]="'layout.configurations.jira.dialog.pkeyPlaceholder' | translate" />
        <small *ngIf="selectedPkey.pkey && !isPkeyValid" class="p-error">
          {{ 'layout.configurations.jira.validation.pkeyFormat' | translate }}
        </small>
      </div>

      <div class="field">
        <label class="font-bold">{{ 'layout.configurations.jira.status' | translate }}</label>
        <p-dropdown 
          [options]="statusOptions" 
          [(ngModel)]="selectedPkey.status" 
          optionLabel="label" 
          optionValue="value"
          placeholder="{{ 'layout.configurations.jira.status' | translate }}"
          appendTo="body">
        </p-dropdown>
      </div>

    </div>

    <ng-template pTemplate="footer">
      <p-button label="{{ 'common.cancel' | translate }}" severity="secondary" [text]="true" (onClick)="displayDialog = false"></p-button>
      <p-button label="{{ 'common.save' | translate }}" [disabled]="!isPkeyValid" (onClick)="savePkey()"></p-button>
    </ng-template>
  </p-dialog>
</div>
